/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestGetLauncherAppManifestResultFromJSON, FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestGetLauncherAppManifestResultToJSON, } from './FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestGetLauncherAppManifestResult';
/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponse interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponse(value) {
    if (!('Manifest' in value) || value['Manifest'] === undefined)
        return false;
    if (!('AvailableBranches' in value) || value['AvailableBranches'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponseFromJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Manifest': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestGetLauncherAppManifestResultFromJSON(json['Manifest']),
        'AvailableBranches': json['AvailableBranches'],
    };
}
export function FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponseToJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Manifest': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestGetLauncherAppManifestResultToJSON(value['Manifest']),
        'AvailableBranches': value['AvailableBranches'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFtlIntegrationLauncherLauncherManifestResponse.js.map